var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-common',{attrs:{"action":_vm.apply,"disabled":_vm.disabled}},[_vm._v("\n  "+_vm._s(_vm.buttonTitle)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }